import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export interface AdminProfile {
  user_id: string;
  first_name: string | null;
  last_name: string | null;
}

export function useAdminProfile() {
  const { user } = useAuth();
  const [profile, setProfile] = useState<AdminProfile | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchProfile = async () => {
    if (!user) { setProfile(null); setLoading(false); return; }
    const { data } = await supabase
      .from("user_admin_profile")
      .select("*")
      .eq("user_id", user.id)
      .maybeSingle();
    setProfile(data ?? null);
    setLoading(false);
  };

  useEffect(() => { fetchProfile(); }, [user?.id]);

  const updateProfile = async (first_name: string, last_name: string) => {
    if (!user) return;
    const { error } = await supabase
      .from("user_admin_profile")
      .upsert({ user_id: user.id, first_name, last_name });
    if (!error) await fetchProfile();
    return { error };
  };

  const displayName = profile?.first_name || profile?.last_name
    ? [profile.first_name, profile.last_name].filter(Boolean).join(" ")
    : null;

  return { profile, loading, updateProfile, displayName, refetch: fetchProfile };
}
